import loadable from "@loadable/component";
import {AccountsRoutes, HomeRoutes} from "./Children";
const EmailsIntegrationSettings = loadable(() =>
  import("../Views/Home/mailbox/EmailIntegrationSettings.Component")
);
const AccountsLayout = loadable(() =>
  import("../Layouts/Accounts/Accounts.Layout")
);
const HomeLayout = loadable(() => import("../Layouts/Home/Home.Layout"));

export const AppRoutes = [
  {
    path: "accounts",
    name: "Accounts",
    component: AccountsLayout,
    layout: "",
    default: true,
    authorize: false,
    isRecursive: false,
    roles: [],
    isRoute: true,
    children: AccountsRoutes,
  },
  {
    path: "home",
    name: "Home",
    component: HomeLayout,
    layout: "",
    default: false,
    isRecursive: true,
    authorize: true,
    roles: [],
    isRoute: true,
    children: HomeRoutes,
  },
  {
    path: "/mailbox/booking",
    name: "Booking",
    component: EmailsIntegrationSettings,
    layout: "",
    default: false,
    isRecursive: true,
    authorize: true,
    roles: [],
    isRoute: true,
    children: [],
  },
];
